var NeatolabsTakeyaCart = {
    // ---------------------------------------------------
    // Handle Add to Cart
    // ---------------------------------------------------
    updateTheme : (product) => {
        console.log("update Theme----", product)
        theme.productCards = theme?.productCards || {};
        theme.productCards[product?.id] = [{
            "available": product.available,
            "badgeText": "",
            "color": product.variants?.[0]?.option2,
            "compareAtPrice": 0,
            "id": product?.variants?.[0]?.id,
            "imageSrc": product?.featured_image,
            "inventory": product?.variants?.[0]?.inventory_quantity,
            "price": product?.price,
            "size" :product.variants?.[0]?.option1,
            "url": `/products/${product?.handle}?variant=${product?.variants?.[0]?.id}`
        }];
        theme.variants = theme?.variants || {}
        theme.variants[product?.variants?.[0]?.id] = {
            "available" : product.available,
            "badgeText" : "",
            "color":product.variants?.[0]?.option2,
            "compareAtPrice" : 0,
            "id" : product?.variants?.[0]?.id,
            "imageSrc":"",
            "inventory":product?.variants?.[0]?.inventory_quantity,
            "price":product?.price,
            "size":product.variants?.[0]?.option1,
            "url": `/products/${product?.handle}?variant=${product?.variants?.[0]?.id}`
        };
        
    },
    updatePage : (product) => {
        
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/products/${product.handle}?variant=${product.variants[0].id}`;
        //window.location.href = `/cart`;
        
        
        return;
        const page = document.querySelector("body .product__info")
        const images = page.querySelectorAll(".product__info__main-image img")
        
        
        images.forEach((image, index) => {
            image.src = product.image.src
        })
        
        const price = page.querySelector(".product__info__price span")
        price.innerText = `$${product.variants[0].price}`
        
        const barPrice = document.querySelector(".product__add-to-cart-bar__prices .h4")
        barPrice.innerText = `$${product.variants[0].price}`
        
        console.log("product---------->", product)
        
    },
    
    /*addToCart : async (form)=> {
        //const form = document.querySelector("body.customized_product #add-to-cart-bar-product-form")
        const quantity = form.querySelector("input[name='quantity']").value
        const productId = form.querySelector("input[name='product-id']").value
        const variantId = form.querySelector("input[name='id']").value
        await window.theme.addToCart([{
            ['id']: variantId,
            ['quantity']: quantity,
            ['properties']: neatolabsCustomizationProperties[variantId],
            ['product-id']: productId
        }])
    },*/
    remove : async (variantId)=> {
        await fetch(`/cart/change?id=${variantId}&quantity=0`)
        const itemRow = document.querySelector(`.cart__item[data-variant='${variantId}']`);
        const input = itemRow.querySelector(`#quantity`);
        //const quantity = parseInt(input.value)
        input.value = 0
        itemRow.remove()
    },
    shopifyAddToCart: async (data) => {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                items: data
            })
        })
    },
    add : async (data)=> {
        
        if (!data?.properties?._data || !JSON.parse(data?.properties?._data).store_name) {alert("Something went wrong. Please try again."); return;}
        console.log("message", data, JSON.parse(data?.properties?._data), JSON.parse(data?.properties?._data).store_name)
      
        NeatolabsTakeyaCart.updateTheme(data.new_product)
        // Close the modal
        Neatolabs.control.modal.closeModal();
        
        const properties = data.properties;
        const productId = data.new_product.id
        const variantId = data.new_product.variants[0].id
        let quantity = data.quantity
        const isModified = data.is_modified
        
        if (isModified) {
            await NeatolabsTakeyaCart.remove(Neatolabs.data.product.variant_id)
            await NeatolabsTakeyaCart.shopifyAddToCart([{
                ['id']: variantId,
                ['quantity']: quantity,
                ['properties']: properties,
                ['product-id']: productId
            }])
            NeatolabsTakeyaCart.updatePage(data.new_product);
        } else {
            await window.theme.addToCart([{
                ['id']: variantId,
                ['quantity']: quantity,
                ['properties']: properties,
                ['product-id']: productId
            }]);
        }
        
        
        
        /*if (isModified) {
            NeatolabsTakeyaCart.updatePage(data.new_product);
        }*/
        
        
        
    },
}